import React from 'react';
import { Text } from '../components/Text';
import { formatRelativeTime } from '../utils/format';
import { ICaremapNoteResponse } from '../notes/model/NotesClient';
import { IAction, Menu } from '../components/Menu';
import { DeleteIcon, EditIcon } from '../theme/Icons';

type ICommentViewProps = {
    comment: ICaremapNoteResponse;
    editHandler?: (comment: ICaremapNoteResponse) => void;
    deleteHandler?: (comment: ICaremapNoteResponse) => void;
};

export const CommentViewer: React.FC<ICommentViewProps> = ({ comment, editHandler, deleteHandler }) => {
    const actions: IAction[] = [];
    if (editHandler) {
        actions.push({
            Icon:
            EditIcon,
            text: `Edit Comment`,
            'data-type': 'edit-button',
            handler: () => editHandler(comment)
        });
    }

    if (deleteHandler) {
        actions.push({
            Icon: DeleteIcon,
            role: 'destructive',
            text: `Delete Comment`,
            'data-type': 'delete-button',
            handler: () => deleteHandler(comment)
        });
    }

    return (
        <div style={{background: 'var(--ion-color-light)', borderRadius: 8, padding: 10}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                <div style={{flexGrow: 1}}>
                    <Text type="subtitle">
                        <span className="mp-mask">{comment.createdByUser?.firstName || 'Anonymous'}&nbsp;{comment.createdByUser?.lastName}</span>
                    </Text>
                    <div style={{fontSize: 14}}>
                        <Text type="detail">{formatRelativeTime(comment.createdAt)}</Text>
                    </div>
                </div>
                {actions.length ? (
                    <div style={{marginTop: -10}}>
                        <Menu data-id="comment-actions" actions={actions} />
                    </div>
                ) : null}
            </div>

            <div style={{marginTop: 5}}>
                <Text data-type="content">{comment.html || '[No text]'}</Text>
            </div>
        </div>
    );
};
